export class ErrorResponse {
    message: string;
    status: any;
}
